<template>
  <div class="form-field form-floating" :class="fieldType + '-field'">
    <template v-if="element">
      <component
        :is="customComponent(element)"
        :disabled="disabled"
        :name="name"
        :id="id"
        :placeholder="label"
        :property-elements="propertyElements"
        :property-labels="propertyLabels"
        :property-resource-types="propertyResourceTypes"
        :readonly="readonly"
        :required="required"
        :resource-type="resourceType"
        :step="fieldType === 'datetime' ? 1 : null"
        :value="value"
        :options="options"
        :choices="choices"
        :label="labelAttribute"
        :media="fieldType === 'media' ? value : null"
        :errors="error ? { error } : null"
        @update:data="(data) => updateData(data)"
        @update:model="(attributes, relations) => $emit('update:model', attributes, relations)"
        @update:toasts="$emit('update:toasts', $event)"
        @update:media="(media) => $emit('update:media', media)"
      ></component>
    </template>
    <template v-else>
      <div class="bg-danger p-2">Component missing for "{{ name }}"!</div>
      <!--      <form-multi-select-->
      <!--        v-if="fieldType === 'select-multiple'"-->
      <!--        :disabled="disabled"-->
      <!--        :name="name"-->
      <!--        :options="choices"-->
      <!--        :values="value"-->
      <!--        @update:data="(event) => updateData(event.target.value)"-->
      <!--      ></form-multi-select>-->
    </template>
    <div v-if="error" class="invalid-feedback" role="alert">
      <strong>{{ error }}</strong>
    </div>
    <slot name="label">
      <label
        v-if="label"
        :for="name"
        :style="getLabelStyle()"
        :class="{ 'has-content': value !== null && value !== '' }"
      >{{ labelAttribute }}</label
      >
    </slot>
  </div>
</template>

<script>
import useCustomComponent from '@kanrisha/composables/useCustomComponent';

export default {
  components: {
  },
  props: {
    error: { type: String, default: null },
    id: { type: String, default: '' },
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    label: { type: String, default: '' },
    choices: { type: [Array, Object], default: () => [] },
    options: { type: Object, default: () => {} },
    fieldType: { type: String, default: 'text' },
    resourceType: { type: String, default: '' },
    element: { type: String, default: () => null },
    propertyElements: { type: Object, default: () => {} },
    propertyLabels: { type: Object, default: () => {} },
    propertyResourceTypes: { type: Object, default: () => {} },
    value: { type: [Number, String, Boolean, Array, Object], default: () => '' },
  },
  emits: ['update:data', 'update:attribute', 'update:model', 'update:toasts', 'update:media'],
  setup(props, { emit }) {
    const { customComponent } = useCustomComponent();

    const getLabelStyle = () => {
      let typesWithLabelOutside = ['json', 'translatable', 'checkboxes', 'radios'];

      if (typesWithLabelOutside.includes(props.fieldType)) {
        if (props.fieldType === 'checkboxes' || props.fieldType === 'radios') {
          return 'margin-top:-0.375rem;';
        }

        return 'margin-top:-1.25rem; margin-left:-0.5rem;';
      }

      if (props.fieldType === 'media') {
        return 'pointer-events: auto;';
      }

      return '';
    };

    const updateData = (data) => {
      emit('update:attribute', data);
      emit('update:data', data); // remove this after refactoring
    };

    return {
      customComponent,
      getLabelStyle,
      updateData,
    };
  },
  computed: {
    labelAttribute() {
      return this.required ? `${this.label} *` : this.label;
    },
  },
};
</script>
